import { jsxs, jsx } from "react/jsx-runtime";
import { u as useLocalization, b as cn } from "./base-provider-Br-ghcgu.js";
import '../assets/tailwind-C7HWuNiW.css';const MeasInfoHeaderTokenized = function MeasInfoHeaderTokenized2({
  children,
  customSubTitle = "",
  customTitle = "",
  hasBottomOffset = true,
  hasTopOffset = true,
  dataTestId
}) {
  const t = useLocalization();
  const title = customTitle || t("shared.infoHeader.defaultTitle");
  return /* @__PURE__ */ jsxs("div", { className: cn("mx-auto max-w-300 font-sans text-center text-text", {
    "pt-32": hasTopOffset,
    "pb-32": hasBottomOffset
  }), "data-testid": dataTestId, children: [
    /* @__PURE__ */ jsx("div", { className: "text-xl leading-xl font-medium whitespace-pre-line", "data-testid": dataTestId ? `${dataTestId}-title` : void 0, children: title }),
    customSubTitle ? /* @__PURE__ */ jsx("div", { className: "mx-auto mt-8 text-center text-sm leading-base font-light whitespace-pre-line", children: customSubTitle }) : null,
    /* @__PURE__ */ jsx("div", { children })
  ] });
};
export {
  MeasInfoHeaderTokenized as M
};
